"use strict";

/*==============================================================================*
*TRESTLE™ W006
*REMIND ME + TRESTLE HUMOUR
*Version 1.0
*==============================================================================*/

(function(){

/*==============================================================================*
*CONFIG
*==============================================================================*/

const CONFIG={

    reminderStorageKey:
        "trestle_w006_reminders",

    maxReminders:
        5

};


/*==============================================================================*
*RUNTIME
*==============================================================================*/

let root=null;

let reminders=[];

/*==============================================================================*
*REMIND ME MEMBERSHIP ACCESS
*==============================================================================*/

function canAccessRemindMe(){

    return Boolean(

        window.TrestleAccess &&

        (
            window.TrestleAccess.isCorporate === true ||
            window.TrestleAccess.isIndividual === true ||
            window.TrestleAccess.isAdminApproved === true
        )

    );

}

/*==============================================================================*
*RENDER REMIND ME LOCKED STATE
*==============================================================================*/

function renderRemindMeLockedState(){

    if(!root){
        return;
    }


    const input=
        root.querySelector(
            "#trW006ReminderInput"
        );


    const addButton=
        root.querySelector(
            "#trW006AddReminder"
        );


    const list=
        root.querySelector(
            "#trW006ReminderList"
        );


    const empty=
        root.querySelector(
            "#trW006Empty"
        );


    const count=
        root.querySelector(
            "#trW006Count"
        );


    if(input){

        input.value="";

        input.disabled=true;

        input.placeholder=
            "Available with Corporate or Individual Membership";

    }


   if(addButton){

    addButton.disabled=false;

    addButton.textContent=
        "Membership Required";

    addButton.onclick=()=>{

        window.location.href=
            "https://www.diafemme.com/pages/trestle-membership";

    };

}


    if(count){

        count.textContent=
            "Membership";

    }


    if(empty){

        empty.hidden=true;

    }


    if(list){

        list.innerHTML=`

            <div class="tr-w006-membership-lock">

                <strong>
                    Remind Me is a TRESTLE Membership feature.
                </strong>

                <p>
                    Available with Corporate or Individual Membership.
                </p>

            </div>

        `;

    }

}

/*==============================================================================*
*DATE KEY
*==============================================================================*/

function getTodayKey(){

    const now=
        new Date();


    const year=
        now.getFullYear();


    const month=
        String(
            now.getMonth()+1
        ).padStart(
            2,
            "0"
        );


    const day=
        String(
            now.getDate()
        ).padStart(
            2,
            "0"
        );


    return(
        year+
        "-"+
        month+
        "-"+
        day
    );

}


/*==============================================================================*
*TIMESTAMP
*==============================================================================*/

function getTimestamp(){

    return new Date().toISOString();

}


/*==============================================================================*
*ENTRY ID
*==============================================================================*/

function createReminderId(){

    return(
        "w006_" +
        Date.now().toString(36) +
        "_" +
        Math.random()
            .toString(36)
            .slice(2,8)
    );

}


/*==============================================================================*
*ESCAPE HTML
*==============================================================================*/

function escapeHTML(value){

    if(
        value===null ||
        typeof value==="undefined"
    ){

        return"";

    }


    return String(value)

        .replace(/&/g,"&amp;")
        .replace(/</g,"&lt;")
        .replace(/>/g,"&gt;")
        .replace(/"/g,"&quot;")
        .replace(/'/g,"&#039;");

}


/*==============================================================================*
*READ REMINDERS
*
*LOCAL STORAGE ONLY.
*NO BACKEND.
*==============================================================================*/

function loadReminders(){

    try{

        const raw=
            localStorage.getItem(
                CONFIG.reminderStorageKey
            );


        if(!raw){

            reminders=[];

            return;

        }


        const parsed=
            JSON.parse(raw);


        reminders=
            Array.isArray(parsed)
                ? parsed
                : [];

    }


    catch(error){

        console.warn(
            "TRESTLE W006 reminder read error",
            error
        );


        reminders=[];

    }

}


/*==============================================================================*
*SAVE REMINDERS
*
*LOCAL STORAGE ONLY.
*==============================================================================*/

function saveReminders(){

    try{

        localStorage.setItem(

            CONFIG.reminderStorageKey,

            JSON.stringify(
                reminders
            )

        );


        return true;

    }


    catch(error){

        console.warn(
            "TRESTLE W006 reminder save error",
            error
        );


        return false;

    }

}


/*==============================================================================*
*ACTIVE COUNT
*==============================================================================*/

function getActiveCount(){

    return reminders.filter(

        function(item){

            return item.completed!==true;

        }

    ).length;

}


/*==============================================================================*
*ADD REMINDER
*==============================================================================*/

function addReminder(){

    if(!root){

        return;

    }


    const input=
        root.querySelector(
            "#trW006ReminderInput"
        );


    if(!input){

        return;

    }


    const text=
        String(
            input.value || ""
        ).trim();


    if(!text){

        return;

    }


    if(
        getActiveCount()>=
        CONFIG.maxReminders
    ){

        alert(
            "You can keep up to 5 active reminders."
        );

        return;

    }


    reminders.unshift({

        id:
            createReminderId(),

        text:
            text.slice(
                0,
                120
            ),

        completed:
            false,

        createdAt:
            getTimestamp(),

        updatedAt:
            getTimestamp(),

        completedAt:
            null

    });


    saveReminders();


    input.value="";


    renderReminders();


    broadcastReminderUpdate();

}


/*==============================================================================*
*COMPLETE / UNCOMPLETE
*==============================================================================*/

function toggleReminder(id){

    const item=
        reminders.find(

            function(reminder){

                return reminder.id===id;

            }

        );


    if(!item){

        return;

    }


    item.completed=
        !item.completed;


    item.updatedAt=
        getTimestamp();


    item.completedAt=
        item.completed
            ? getTimestamp()
            : null;


    saveReminders();


    renderReminders();


    broadcastReminderUpdate();

}


/*==============================================================================*
*DELETE
*==============================================================================*/

function deleteReminder(id){

    reminders=
        reminders.filter(

            function(item){

                return item.id!==id;

            }

        );


    saveReminders();


    renderReminders();


    broadcastReminderUpdate();

}


/*==============================================================================*
*EDIT
*==============================================================================*/

function editReminder(id){

    const item=
        reminders.find(

            function(reminder){

                return reminder.id===id;

            }

        );


    if(!item){

        return;

    }


    const revised=
        window.prompt(
            "Edit reminder",
            item.text
        );


    if(revised===null){

        return;

    }


    const text=
        String(revised).trim();


    if(!text){

        return;

    }


    item.text=
        text.slice(
            0,
            120
        );


    item.updatedAt=
        getTimestamp();


    saveReminders();


    renderReminders();


    broadcastReminderUpdate();

}


/*==============================================================================*
*RENDER REMINDERS
*==============================================================================*/

function renderReminders(){

    if(!root){

        return;

    }


    const list=
        root.querySelector(
            "#trW006ReminderList"
        );


    const empty=
        root.querySelector(
            "#trW006Empty"
        );


    const count=
        root.querySelector(
            "#trW006Count"
        );


    if(
        !list ||
        !empty ||
        !count
    ){

        return;

    }


    const activeCount=
        getActiveCount();


    count.textContent=

        activeCount +
        " / " +
        CONFIG.maxReminders;


    if(
        reminders.length===0
    ){

        list.innerHTML="";

        empty.hidden=false;

        return;

    }


    empty.hidden=true;


    list.innerHTML=

        reminders.map(

            function(item){

                const completeClass=
                    item.completed
                        ? " is-complete"
                        : "";


                const completeLabel=
                    item.completed
                        ? "Mark as not complete"
                        : "Mark complete";


                return`

                    <div
                        class="tr-w006-reminder-item${completeClass}"
                        data-reminder-id="${escapeHTML(item.id)}"
                    >

                        <div class="tr-w006-reminder-text">

                            ${escapeHTML(item.text)}

                        </div>


                        <div class="tr-w006-reminder-actions">


                            <button
                                type="button"
                                class="tr-w006-action"
                                data-reminder-action="complete"
                                aria-label="${completeLabel}"
                                title="${completeLabel}"
                            >
                                ✓
                            </button>


                            <button
                                type="button"
                                class="tr-w006-action"
                                data-reminder-action="edit"
                                aria-label="Edit reminder"
                                title="Edit"
                            >
                                ✎
                            </button>


                            <button
                                type="button"
                                class="tr-w006-action"
                                data-reminder-action="delete"
                                aria-label="Delete reminder"
                                title="Delete"
                            >
                                ×
                            </button>


                        </div>

                    </div>

                `;

            }

        ).join("");

}


/*==============================================================================*
*REMINDER UPDATE EVENT
*==============================================================================*/

function broadcastReminderUpdate(){

    window.dispatchEvent(

        new CustomEvent(

            "trestle-w006-reminders-updated",

            {

                detail:{

                    reminders:
                        JSON.parse(
                            JSON.stringify(
                                reminders
                            )
                        )

                }

            }

        )

    );

}


/*==============================================================================*
*HUMOUR DATA
*==============================================================================*/

function getHumourData(){

    if(
        typeof TRESTLE_W006_HUMOUR_DATA==="undefined" ||
        !Array.isArray(
            TRESTLE_W006_HUMOUR_DATA
        )
    ){

        return[];

    }


    return TRESTLE_W006_HUMOUR_DATA

        .filter(

            function(item){

                return(
                    item &&
                    item.date &&
                    item.image
                );

            }

        )

        .slice();

}


/*==============================================================================*
*SELECT CARTOON
*
*1. Today's dated cartoon
*2. Otherwise latest dated cartoon not later than today
*3. Otherwise latest available cartoon
*==============================================================================*/

function selectCartoon(){

    const cartoons=
        getHumourData();


    if(!cartoons.length){

        return null;

    }


    const today=
        getTodayKey();


    const exact=
        cartoons.find(

            function(item){

                return item.date===today;

            }

        );


    if(exact){

        return exact;

    }


    const sorted=
        cartoons.sort(

            function(a,b){

                return(
                    String(b.date)
                        .localeCompare(
                            String(a.date)
                        )
                );

            }

        );


    const pastOrToday=
        sorted.find(

            function(item){

                return item.date<=today;

            }

        );


    if(pastOrToday){

        return pastOrToday;

    }


    return sorted[0];

}


/*==============================================================================*
*RENDER CARTOON
*==============================================================================*/

function renderCartoon(){

    if(!root){

        return;

    }


    const image=
        root.querySelector(
            "#trW006Cartoon"
        );


    if(!image){

        return;

    }


    const cartoon=
        selectCartoon();


    if(!cartoon){

        image.removeAttribute(
            "src"
        );

        image.alt=
            "No TRESTLE Humour cartoon available.";

        return;

    }


    image.src=
        cartoon.image;


    image.alt=
        "TRESTLE Humour cartoon of the day";

}


/*==============================================================================*
*EVENTS
*==============================================================================*/

function bindEvents(){

    if(!root){

        return;

    }


    const addButton=
        root.querySelector(
            "#trW006AddReminder"
        );


    const input=
        root.querySelector(
            "#trW006ReminderInput"
        );


    if(addButton){

        addButton.addEventListener(

            "click",

            addReminder

        );

    }


    if(input){

        input.addEventListener(

            "keydown",

            function(event){

                if(
                    event.key==="Enter"
                ){

                    event.preventDefault();

                    addReminder();

                }

            }

        );

    }


    root.addEventListener(

        "click",

        function(event){

            const actionButton=
                event.target.closest(
                    "[data-reminder-action]"
                );


            if(!actionButton){

                return;

            }


            const item=
                actionButton.closest(
                    "[data-reminder-id]"
                );


            if(!item){

                return;

            }


            const id=
                item.dataset.reminderId;


            const action=
                actionButton.dataset.reminderAction;


            if(
                action==="complete"
            ){

                toggleReminder(id);

            }


            if(
                action==="edit"
            ){

                editReminder(id);

            }


            if(
                action==="delete"
            ){

                deleteReminder(id);

            }

        }

    );

}


/*==============================================================================*
*PUBLIC API
*
*Reminders remain localStorage-only.
*This API only exposes the current browser's local state.
*==============================================================================*/

window.TrestleW006={


    getReminders:function(){

        return JSON.parse(

            JSON.stringify(
                reminders
            )

        );

    },


    getActiveReminders:function(){

        return JSON.parse(

            JSON.stringify(

                reminders.filter(

                    function(item){

                        return item.completed!==true;

                    }

                )

            )

        );

    },


    getCompletedReminders:function(){

        return JSON.parse(

            JSON.stringify(

                reminders.filter(

                    function(item){

                        return item.completed===true;

                    }

                )

            )

        );

    },


    getCartoonOfTheDay:function(){

        const cartoon=
            selectCartoon();


        return cartoon
            ? JSON.parse(
                JSON.stringify(
                    cartoon
                )
            )
            : null;

    }

};


/*==============================================================================*
*INIT
*==============================================================================*/

function init(){

    root=
        document.getElementById(
            "trW006"
        );


    if(!root){

        return;

    }


    /*
    HUMOUR
    Available to all TRESTLE users.
    */

    renderCartoon();


    /*
    REMIND ME
    Corporate / Individual / Admin-approved access only.
    */

    if(
        !canAccessRemindMe()
    ){

        renderRemindMeLockedState();


        console.log(
            "TRESTLE W006 Ready — Remind Me Locked"
        );


        return;

    }


    loadReminders();


    renderReminders();


    bindEvents();


    console.log(
        "TRESTLE W006 Ready"
    );

}


/*==============================================================================*
*BOOTSTRAP
*==============================================================================*/

if(
    document.readyState==="loading"
){

    document.addEventListener(

        "DOMContentLoaded",

        init

    );

}

else{

    init();

}

})();